module.exports = __webpack_public_path__ + "static/media/kid_avatar_04.d5aa8940.png";